import type { Dispatch, FC, ReactNode, SetStateAction } from 'react'
import { createContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { userSettings } from '@/redux/user/selectors'

export interface ILegalConsentContext {
  setContext: Dispatch<SetStateAction<ILegalConsentContext>>
  showLegalConsent: boolean
  setShowLegalConsent: Dispatch<SetStateAction<boolean>>
}

interface Props {
  children: ReactNode
}

const legalConsentContext = createContext({} as ILegalConsentContext)
const LegalConsentContextProvider = legalConsentContext.Provider

export const LegalConsentProvider: FC<Props> = ({ children }) => {
  const initialValue: ILegalConsentContext = {
    showLegalConsent: false,
    setShowLegalConsent: null as unknown as Dispatch<SetStateAction<boolean>>,
    setContext: null as unknown as Dispatch<
      SetStateAction<ILegalConsentContext>
    >
  }

  const [context, setContext] = useState(initialValue)

  const currentUserSettings = useSelector(userSettings)

  useEffect(() => {
    if (!currentUserSettings) return

    const showLegalConsent =
      !currentUserSettings?.termAndConditionsAccepted ||
      !currentUserSettings?.privacyPolicyAccepted

    setContext(prevContext => {
      return {
        ...prevContext,
        showLegalConsent
      }
    })
  }, [currentUserSettings])

  return (
    <LegalConsentContextProvider value={{ ...context, setContext }}>
      {children}
    </LegalConsentContextProvider>
  )
}

export default legalConsentContext
